import { useState, useEffect } from 'react';

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Mostrar solo si no se descartó antes
      const dismissed = localStorage.getItem('pwa_dismissed');
      if (!dismissed) setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa_dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
      background: '#1a237e', color: '#fff', borderRadius: 12, padding: '12px 20px',
      display: 'flex', alignItems: 'center', gap: 16, zIndex: 99999,
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)', maxWidth: '90%', width: 420,
    }}>
      <div style={{ fontSize: 28 }}>💻</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 14 }}>Instalar Ai-leth</div>
        <div style={{ fontSize: 12, opacity: 0.8 }}>Accede más rápido desde tu escritorio</div>
      </div>
      <button onClick={handleInstall} style={{
        background: '#00e676', color: '#000', border: 'none', borderRadius: 8,
        padding: '8px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer',
      }}>Instalar</button>
      <button onClick={handleDismiss} style={{
        background: 'none', border: 'none', color: '#aaa', fontSize: 18, cursor: 'pointer', padding: '4px 8px',
      }}>✕</button>
    </div>
  );
}
